import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { FormControl, MenuItem, Select } from '@mui/material'

import { changeLanguage, getSupportedLanguages, normalizeLanguage } from 'i18n'
import { SET_LOCALE } from 'store/actions'

const LANGUAGE_LABELS = {
  en: 'English',
  hu: 'Magyar',
  pseudo: 'Pseudo',
}

// ==============================|| LANGUAGE SWITCHER ||============================== //

const LanguageSwitcher = ({ onOpenChange }) => {
  const { i18n, t } = useTranslation()
  const dispatch = useDispatch()

  const current = normalizeLanguage(i18n.resolvedLanguage) || 'en'

  const handleChange = (event) => {
    const language = event.target.value
    dispatch({ type: SET_LOCALE, locale: language })
    changeLanguage(language)
  }

  return (
    <FormControl size="small">
      <Select
        value={current}
        onChange={handleChange}
        onOpen={() => onOpenChange?.(true)}
        onClose={() => onOpenChange?.(false)}
        inputProps={{ 'aria-label': t('common:language.label') }}
        sx={{ minWidth: 120, fontSize: '0.875rem' }}
      >
        {getSupportedLanguages().map((language) => (
          <MenuItem key={language} value={language}>
            {LANGUAGE_LABELS[language] || language}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

LanguageSwitcher.propTypes = {
  onOpenChange: PropTypes.func,
}

export default LanguageSwitcher
